import React  from "react";
import { useParams } from 'react-router-dom';
import EmployeeDocuments from "./components/EmployeeDocuments";



const ViewEmployeeDetail = () => {
	const { employeeId } = useParams();
    
	return (
	    <div className="mt-6">
	    	<EmployeeDocuments recordId={employeeId} mode="view"/>
	    </div>
    );
};

export default ViewEmployeeDetail;